export type CssDeclarationValue = string | Record<string, string>;

export type CssObject = Record<string, Record<string, CssDeclarationValue>>;

const isAtRule = (key: string): boolean => key.startsWith('@');

export const parseCssObject = (css?: string): CssObject | undefined => {
  if (!css) return;

  try {
    return JSON.parse(css);
  } catch {
    return;
  }
};

export const selfOrDescendant = (selector: string): string => `&${selector}, ${selector}`;

export const scopeSelfOrDescendant = (cssObject?: CssObject): CssObject | undefined => {
  if (!cssObject) return;

  return Object.fromEntries(
    Object.entries(cssObject).map(([selector, declarations]) => [
      selfOrDescendant(selector),
      declarations,
    ])
  );
};

export const cssObjectToString = (cssObject?: CssObject): string => {
  if (!cssObject) return '';

  const hoistedAtRules: string[] = [];

  const selectorBlocks = Object.entries(cssObject)
    .map(([selector, declarations]) => {
      const regularDecls: string[] = [];

      for (const [property, value] of Object.entries(declarations)) {
        if (typeof value === 'object' && value !== null && isAtRule(property)) {
          const nestedBody = Object.entries(value)
            .map(([prop, val]) => `      ${prop}: ${val};`)
            .join('\n');

          hoistedAtRules.push(
            `  ${property} {\n    ${selector} {\n${nestedBody}\n    }\n  }`,
          );
          continue;
        }

        if (typeof value === 'string') {
          regularDecls.push(`    ${property}: ${value};`);
        }
      }

      return `  ${selector} {\n${regularDecls.join('\n')}\n  }`;
    })
    .join('\n');

  const atRuleBlocks = hoistedAtRules.join('\n');

  return [selectorBlocks, atRuleBlocks].filter(Boolean).join('\n\n');
};
